import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { EcommerceAppComponent } from './app/ecommerce-app.component';

bootstrapApplication(EcommerceAppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  // eslint-disable-next-line no-console
  .catch(err => console.error(err));
